const jobExperienceManager = (jobExperience: any) => {
  const startDate = new Date(jobExperience.start_date);
  const endDate = new Date(jobExperience.end_date);

  return {
    employer: jobExperience.employer,
    workAssignment: jobExperience.work_assignment,
    startMonth: startDate.getMonth() + 1,
    startYear: startDate.getFullYear(),
    endMonth: endDate.getMonth() + 1,
    endYear: endDate.getFullYear(),
    workDescription: jobExperience.description,
  };
};

export default jobExperienceManager;
